/**
 * Binom landings list hook — backs the BinomLanderPicker modal.
 *
 * For Media Devoted | Created By Ciro Autiero
 */

import { useQuery } from '@tanstack/react-query';

import api from '@/services/api';
import { binomKeys } from './useBinom';

export interface BinomLanding {
  id: string;
  name: string;
  url?: string;
  languageCode?: string;
}

const landingsKey = (search: string) =>
  [...binomKeys.all, 'landings', search] as const;

export function useBinomLandings(search = '') {
  return useQuery({
    queryKey: landingsKey(search),
    queryFn: async () => {
      const qs = search ? `?search=${encodeURIComponent(search)}` : '';
      const r = await api.get<{ data: BinomLanding[] | unknown }>(
        `/binom/landings${qs}`,
      );
      const d = r.data?.data;
      if (Array.isArray(d)) return d;
      const items = (d as { items?: BinomLanding[] } | undefined)?.items;
      return Array.isArray(items) ? items : [];
    },
    staleTime: 60_000,
  });
}
